import { Link } from "react-router-dom";
import { MapPin, Instagram, Mail, LogIn } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const ADDRESS = "Jl. Letjen S. Parman No.80A, Gilingan, Kec. Banjarsari, Kota Surakarta, Jawa Tengah 57134";

const Item = ({ icon: Icon, label, children }) => (
  <div className="flex gap-3">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-sky-300" />
    <div>
      <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{label}</p>
      <div className="mt-1 text-sm leading-relaxed text-slate-200">{children}</div>
    </div>
  </div>
);

export const LandingFooter = () => (
  <footer id="kontak" className="bg-slate-950 text-white" data-testid={LANDING.footer}>
    <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 sm:px-10 md:grid-cols-[1.2fr_2fr]">
      <div>
        <div className="inline-block rounded-md bg-white px-3 py-2"><img src="/logo.png" alt="Arumichi Travel" className="h-9 w-auto" /></div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">Teman perjalanan Anda dari Kota Surakarta.</p>
      </div>
      <div className="grid gap-8 sm:grid-cols-2">
        <Item icon={MapPin} label="Alamat">
          <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`} target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid={LANDING.address}>{ADDRESS}</a>
        </Item>
        <div className="space-y-6">
          <Item icon={Instagram} label="Instagram">
            <a href="https://instagram.com/arumichitravel" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid={LANDING.instagram}>@arumichitravel</a>
          </Item>
          <Item icon={Mail} label="Email">
            <a href="mailto:cs@arumichitravel.com" className="hover:text-white" data-testid={LANDING.email}>cs@arumichitravel.com</a>
          </Item>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 py-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-10">
        <p>© {new Date().getFullYear()} Arumichi Travel. Semua hak dilindungi.</p>
        <Link to="/login" className="inline-flex w-fit items-center gap-1.5 text-slate-400 hover:text-white transition-colors" data-testid={LANDING.staffLogin}>
          <LogIn className="h-3.5 w-3.5" /> Login Staff
        </Link>
      </div>
    </div>
  </footer>
);
